export default "__VITE_ASSET__BL7avCrO__"